// The parentheses are part of the message the browser raises, and matching them
// keeps prose that merely mentions the call from counting as a match.
const SEND_MESSAGE_PATTERN = /\bruntime\.sendMessage\(\)/

// These two name no API, so they are compared whole. Anything of ours that
// quotes one inside a longer sentence is left alone, which is the trade we want:
// these words are ordinary enough that a looser match would eventually swallow
// an error of our own.
const CONNECTION_FAILURE_MESSAGES = [
  'Could not establish connection. Receiving end does not exist.',
  'The message port closed before a response was received.',
]


// A browser extension reaches its own background script through
// `runtime.sendMessage()`, and the call fails when the other end is gone: the
// tab it was aimed at has closed, the background script was never listening, or
// it went away before it answered. The rejection escapes the extension unhandled
// and is reported against whatever page happened to be open, which is how it
// reaches us. There is nothing to attribute it by: the event carries no frames
// at all, so the origin check keeps it rather than guess. The message is the
// only evidence available, and leaning on it is safe here because the extension
// APIs are not ours to call and we never do.
//
export default function isExtensionMessagingError(values) {
  return values.some(({ value }) => {
    const message = value || ''

    return SEND_MESSAGE_PATTERN.test(message) || CONNECTION_FAILURE_MESSAGES.includes(message)
  })
}
